module.exports = __webpack_public_path__ + "premium_purchase_icon_1.png?9fd1fc013157897fcc9ba5fda37c318e";


//////////////////
// WEBPACK FOOTER
// ./static/img/premium_purchase_icon_1.png
// module id = 336
// module chunks = 0